import React from 'react'

const GreenTickOutlineIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="green"
            className="bi bi-check-circle"
            viewBox="0 0 16 16"
        >
            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05L7.477 10.49l-2.474-2.48a.75.75 0 0 1 1.06-1.06l1.94 1.94 4.97-4.97z" />
        </svg>
    )
}

export default GreenTickOutlineIcon
